module.exports = __webpack_public_path__ + "media/images/icons/country_flags/mk-b5eadefbb6da73c9d0cf06f78087fe71.svg";